import { FormControl, TextField, Grid, Box,Button, MenuItem, Card, CardContent } from '@mui/material';

import { CashSection } from './CashSection';
import { DepositSection } from './DepositSection';

export const FormAdminPaymentLawyer = ({ useFetchInit, dataModal }) => {

    const {
        //------------- Generales
        paramsURL,
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    const { formOpeningMode } = globalStates
    
    // ------------------------------------------------ globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormScreen } = Forms
    const { formState, onInputChange } = FormScreen
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const {
        onSubmitForm,
        handleClickHideForm,
        handleChangeTypeTransaction,
        handleChangeAmount,
        handleChangeTypeCurrency,
        handleChangeExchangeRate,
    } = Actions

    const { idreception } = paramsURL
        
    return (
        <Card style={{zIndex:'1'}}>
            <CardContent>
                <div className="pt-4"></div>
                <form onSubmit={(e) => onSubmitForm(e, idreception )}>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_fecha">* Fecha</label>
                                <TextField
                                    id="movimiento_fecha"
                                    name="movimiento_fecha"
                                    value={formState.movimiento_fecha}
                                    onChange={onInputChange}
                                    // label='Fecha'
                                    size='small'
                                    type="date"
                                    variant={(formOpeningMode === 'READONLY' || formState.movimiento_tipo === 'EFECTIVO') ? 'filled' : 'outlined' }
                                    hiddenLabel
                                    InputProps={{
                                        readOnly: (formOpeningMode === 'READONLY' || formState.movimiento_tipo === 'EFECTIVO') ? true : false 
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_tipo">* Tipo</label>
                                <TextField
                                    id="movimiento_tipo"
                                    name="movimiento_tipo"
                                    // label="Tipo de movimiento"
                                    value={formState.movimiento_tipo}
                                    onChange={handleChangeTypeTransaction}
                                    select
                                    size="small"
                                    variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                    // lable="Selecciona una opción"
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: (formOpeningMode === 'READONLY') ? true : false 
                                    }}
                                >
                                    <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                    <MenuItem value='DEPOSITO'>DEPOSITO</MenuItem>
                                    <MenuItem value='EFECTIVO'>EFECTIVO</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-2"></div>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_monto">* Monto</label>
                                <TextField
                                    id="movimiento_monto"
                                    name="movimiento_monto"
                                    value={formState.movimiento_monto}
                                    onChange={handleChangeAmount}
                                    // label='Monto a recibir'
                                    size='small'
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: (formOpeningMode === 'READONLY') ? true : false 
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_moneda">* Moneda</label>
                                <TextField
                                    id="movimiento_moneda"
                                    name="movimiento_moneda"
                                    // label="Moneda"
                                    value={formState.movimiento_moneda}
                                    onChange={handleChangeTypeCurrency}
                                    select
                                    size="small"
                                    variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                    // lable="Selecciona una opción"
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: (formOpeningMode === 'READONLY') ? true : false 
                                    }}
                                >
                                    <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                    <MenuItem value='QUETZAL'>QUETZAL</MenuItem>
                                    <MenuItem value='DOLAR'>DOLAR</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_tipo_cambio">* Tipo de Cambio</label>
                                <TextField
                                    id="movimiento_tipo_cambio"
                                    name="movimiento_tipo_cambio"
                                    value={formState.movimiento_tipo_cambio}
                                    onChange={handleChangeExchangeRate}
                                    // label='Tipo de cambio'
                                    size='small'
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: (formOpeningMode === 'READONLY') ? true : false 
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-2"></div>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_quetzales">* Total en Quetzales</label>
                                <TextField
                                    id="movimiento_quetzales"
                                    name="movimiento_quetzales"
                                    value={formState.movimiento_quetzales}
                                    onChange={onInputChange}
                                    // label='Total en quetzales'
                                    size='small'
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: true
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_dolares">* Total en Dolares</label>
                                <TextField
                                    id="movimiento_dolares"
                                    name="movimiento_dolares"
                                    value={formState.movimiento_dolares}
                                    onChange={onInputChange}
                                    // label='Total en dolares'
                                    size='small'
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: true
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-2"></div>
                    {(formState.movimiento_tipo === 'EFECTIVO') && (
                        <>
                            <CashSection useFetchInit={useFetchInit} dataModal={dataModal}/>
                        </>
                    )}
                    {(formState.movimiento_tipo === 'DEPOSITO') && (
                        <>
                            <DepositSection useFetchInit={useFetchInit} dataModal={dataModal}/>
                        </>
                    )}
                    <div className="pt-2"></div>
                    <Box pt={4}>
                        <Grid container spacing={2} justifyContent="flex-end">
                            <Grid item>
                                <Button
                                    style={{background: "#4b4b4c"}}
                                    variant="contained"
                                    type="submit"
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                </Button>
                                &nbsp; &nbsp;
                                <Button
                                    style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                    type="button"
                                    variant="contained"
                                    onClick={handleClickHideForm}
                                >
                                    <i className="fa-regular fa-circle-left"></i> &nbsp; Volver
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </form>
                <div className="pt-4"></div>
            </CardContent>
        </Card>
    )
    
}
